import { connect } from 'react-redux';

import { getConfig } from '../services/config';
import { getPostPageEnabled } from '../selectors/app-data-selectors';

const withSectionUrl = WrappedComponent => {
  const mapStateToProps = state => {
    const { sectionUrl: feedSectionUrl, postPageSectionUrl } = getConfig();
    const isPostPageEnabled = getPostPageEnabled(state) && postPageSectionUrl;
    const sectionUrl = isPostPageEnabled ? postPageSectionUrl : feedSectionUrl;
    return {
      sectionUrl,
    };
  };

  return connect(
    mapStateToProps,
    {},
  )(WrappedComponent);
};

export default withSectionUrl;
